import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

import { applyItem, GalleryAction, loadMoreItems } from './actions';
import { GalleryPane, GalleryPaneProps } from './GalleryPane';
import { selectCurrentGallery, selectGalleryPane } from './selectors';
import { GalleryPaneTypes } from './typings';

export interface OwnProps {
    paneType: GalleryPaneTypes;
    paneFilters?: React.ReactNode;
    itemRenderer: (index: number) => React.ReactNode;
}

export type StateProps = TStateProps<GalleryPaneProps, OwnProps>;

export type DispatchProps = TDispatchProps<GalleryPaneProps, OwnProps>;

const mapDispatchToProps = (dispatch: Dispatch<GalleryAction>): DispatchProps => {
    return {
        applyItem: (collectionIndex: number) => {
            dispatch(applyItem(collectionIndex));
        },
        loadMoreItems: (limit: number) => {
            dispatch(loadMoreItems(limit));
        }
    };
};

export const mapStateToProps = (state: State, ownProps: OwnProps) => {
    const { preview } = selectCurrentGallery(state.canvasEditor.canvas.galleries);
    const {
        data: { collection, total }
    } = selectGalleryPane(state.canvasEditor.canvas.galleries);
    const { isAllItemsLoading, isMoreItemsLoading } = selectGalleryPane(
        state.canvasEditor.canvas.galleries,
        ownProps.paneType
    );

    return {
        collectionLength: collection.length,
        total,
        isAllItemsLoading,
        isMoreItemsLoading,
        previewItemIndex: preview && preview.paneType === ownProps.paneType ? preview.itemIndex : undefined
    };
};

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps, ownProps: OwnProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps
    };
};

export const GalleryPaneContainer = connect<StateProps, DispatchProps, OwnProps, GalleryPaneProps>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(GalleryPane);
